<template>
  <div>
    <ed-alert
      title="Atenção"
      type="warning"
      description="As tabelas listadas abaixo fazem referência as tabelas de riscos químicos, físicos e biológicos nos documentos do LTCAT. Aqui você pode cadastrar os modelos customizados dessas tabelas."
      class="mb-2"
    />

  <ed-modal :modal="showHtml" width="60%">
    
    <div slot="modal-content">
       <p v-html="formData.html"></p>
    </div>
  </ed-modal>

    <ed-table
      registerName="Inserir Tabela Dinâmica"
      :onRegister="
        this.$root.$session.validarPermissao(571) ? onRegister : null
      "
      :onEdit="onEdit"
      :onDelete="onDelete"
      :onSearch="getTabelaDinamica"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :loadingEditAll="loadingEditAll"
      :pagination="pagination"
      :response="response"
    >
      <div slot="table-export">
        <ed-button
          v-if="tableData.length"
          icon="fa fa-download"
          type="text"
          label="Exportar Tabelas"
          title="Clique aqui para exportar as tabelas e visualizar a extrutura das colunas"
          @click="onExportar"
        />
      </div>
    </ed-table>
  </div>
</template>

<script>
import EdTable from "common/table";
import { EdButton, EdAlert,EdModal } from "template";

export default {
  name: "empresa",
  components: { EdTable, EdButton, EdAlert,EdModal },
  mixins: [],
  data() {
    return {
      formData: {
        id: 0,
        nome: null,
        cbo: null,
        descricao: null,
      },
      pagination: {},
      response: {},
      tableHead: [
        {
          key: "id",
          sortable: true,
          width: "60px",
          label: "Cód",
        },
        {
          key: "nome",
          sortable: true,
          show_html: true,
          label: "Nome",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      tableData: [],
      loadingTable: true,
      loadingEditAll: false,
      showFormEdit: false,
      showHtml:false,
      showFormVinculo: false,
      lstTipoPagamento: [],
    };
  },

  created() {},

  mounted: function () {
    this.getTabelaDinamica();
  },

  methods: {
    onExportar() {
      this.$root.$request.open("ltcat/tabela-dinamica/exportar");
    },

    onRegister() {
      this.$router.push({ name: "ltcat.tabela.cadastrar" });
    },

    onEdit(data) {
      this.$router.push({
        name: "ltcat.tabela.editar",
        params: { id: data.id },
      });
    },

    onHtml(data) {
      this.showHtml = !this.showHtml
      this.formData = data;
    },

    onDelete: function (data) {
      var self = this;

      this.$root.$dialog
        .confirm(
          "O sistema vai excluir " +
            data.length +
            " registro(s). Deseja prosseguir?"
        )
        .then(() => {
          self.loadingEditAll = true;

          this.$root.$request
            .post("/ltcat/tabela-dinamica/deletar", { ids: data })
            .then((result) => {
              self.loadingEditAll = false;

              if (result.status == 200) {
                self.getTabelaDinamica();
                self.edMsg("Registo excluido com sucesso");
              }
            });
        });
    },

    getTabelaDinamica(_search, _page, _pagination, _loading) {
      this.loadingTable = true;
      this.response = {};

      this.$root.$request
        .get("/ltcat/tabela-dinamica", {
          search: _search,
          page: _page,
          pagination: _pagination,
        })
        .then((result) => {
          this.response = result;
          this.loadingTable = false;

          if (result.status == 200) {
            var data = result.data.data,
              tableData = [],
              self = this,
              pagination = result.data;

            for (var i = 0; i < data.length; i++) {
              var item = {
                id: data[i].id,
                nome:
                  '<div style="width:30px;float:left;margin-right:5px;background:' +
                  data[i].cor +
                  '">&nbsp;</div> ' +
                  data[i].nome,
                updated_at: this.$utilidade.toDate(data[i].updated_at),
                _data: data[i],
                options: {
                  disable_delete: !this.$root.$session.validarPermissao(571),
                  disable_edit: !this.$root.$session.validarPermissao(571),
                },
                buttons: [],
              };

              if(data[i].html || true){
                item.buttons.push(
                  {
                    icon: 'fa fa-eye',
                    color: 'warning',
                    title:'Visualizar tabela',
                    click: this.onHtml
                  }
                )
              }

              tableData.push(item);
            }

            this.pagination = pagination;
            this.tableData = tableData;
          }
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// index.vue?13676486